import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";

import { PageContent, SideNavBar, SideNavBarV2 } from "../../components";
import { LeadDialog } from "../../dialogs/LeadDialog";
import { QuoteDialog } from "../../dialogs/QuoteDialog";

import SalesBar from "./SalesBar";
import { SALES_TABS, getView } from "./helper";
import { StyledPageLayout, StyledContent } from "./styles";

const STORAGE_TAB = "Sales-Tab";
const STORAGE_VIEW = "Sales-View";

const getInitial = (param, key, fallback) => {
  if (param != null) return Number(param);
  const cached = localStorage?.getItem(key);
  return cached != null ? Number(cached) : fallback;
};

export const SalesPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const [tab, setTab] = useState(() =>
    getInitial(searchParams.get("tab"), STORAGE_TAB, 1),
  );
  const [viewMode, setViewMode] = useState(() =>
    getInitial(searchParams.get("view"), STORAGE_VIEW, 1),
  );

  const updateParams = (newTab, newView) => {
    setSearchParams({ tab: newTab, view: newView }, { replace: true });
  };

  const onSetTab = (val) => {
    localStorage?.setItem(STORAGE_TAB, val);
    setTab(val);
    updateParams(val, viewMode);
  };

  const onSetViewMode = (val) => {
    localStorage?.setItem(STORAGE_VIEW, val);
    setViewMode(val);
    updateParams(tab, val);
  };

  const ActiveView = getView(tab, viewMode);

  return (
    <PageContent disablePadding white>
      <StyledPageLayout>
        <SideNavBarV2 tabs={SALES_TABS} value={tab} setValue={onSetTab} />
        <StyledContent>
          <SalesBar
            tab={tab}
            viewMode={viewMode}
            setViewMode={onSetViewMode}
          />
          <ActiveView />
        </StyledContent>
      </StyledPageLayout>
      <LeadDialog />
      <QuoteDialog />
    </PageContent>
  );
};

export default SalesPage;
